module.exports = __webpack_public_path__ + "img/download.8a507119.png";